var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 34.7148V21.3815M23.9974 34.7148V13.3815M34.6641 34.7148V29.3815M39.9974 2.71484H7.9974C6.58291 2.71484 5.22635 3.27675 4.22616 4.27694C3.22597 5.27713 2.66406 6.63369 2.66406 8.04818V40.0482C2.66406 41.4627 3.22597 42.8192 4.22616 43.8194C5.22635 44.8196 6.58291 45.3815 7.9974 45.3815H39.9974C41.4119 45.3815 42.7684 44.8196 43.7686 43.8194C44.7688 42.8192 45.3307 41.4627 45.3307 40.0482V8.04818C45.3307 6.63369 44.7688 5.27713 43.7686 4.27694C42.7684 3.27675 41.4119 2.71484 39.9974 2.71484Z",
    stroke: "#ABE138",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatIcon);
export default __webpack_public_path__ + "static/media/stat-icon.de0d74848684a64e6a83ec01e8d4f7f1.svg";
export { ForwardRef as ReactComponent };